<template>
  <div id="app">
    <Preload 
      :class="{'preload_done': !loading}"
    />
    <component
      :is="i"
      v-for="(item, i) in pageData"
      :key="i"
      :data="item"
    />

    <Footer />

    <FormModal
      v-show="isModalOpen"
    />
  </div>
</template>

<script>
  import MainBlock from './components/MainBlock.vue'
  import IdeasBlock from './components/IdeasBlock.vue'
  import AdvantageBlocks from './components/AdvantageBlocks.vue'
  import StepBlock from './components/StepBlock.vue'
  import ShareIdeaBlock from './components/ShareIdeaBlock.vue'
  import SocialNetworkBlock from './components/SocialNetworkBlock.vue'
  import Footer from '@/components/layout/Footer'
  import Preload from '@/components/layout/Preload'
  import FormModal from '@/components/modals/FormModal'
  import CookiesPrivacyPolicy from '@/components/CookiesPrivacyPolicy'
  import dataPage from './data.json'
  import responsive from '@/mixins/responsive'
  import $axios from '@/plugins/axios'
  import get from 'lodash/get'
  import objectFitImages from 'object-fit-images'

  export default {
    name: 'App',
    components: {
      MainBlock,
      IdeasBlock,
      AdvantageBlocks,
      StepBlock,
      ShareIdeaBlock,
      SocialNetworkBlock,
      Footer,
      Preload,
      CookiesPrivacyPolicy,
      FormModal
    },

    mixins: [responsive],

    data () {
      return {
        dataPage,
        pageData: null,
        loading: true,
        errored: false,
        isModalOpen: false,
        theUserAgent: ''
      }
    },

    created () {
      this.get = get
      this.$axios = $axios
      this.requestUrl = `${process.env.VUE_APP_API}/MainPage`
      document.body.style.overflow = 'hidden'
      this.bus.$on('showModal', (data) => {
        this.isModalOpen = true
        document.body.style.overflow = 'hidden'
      })

      this.bus.$on('hideModal', (data) => {
        this.isModalOpen = false
        document.body.style.overflow = ''
      })
    },

    async mounted () {
      this.$axios.get(this.requestUrl)
        .then(response => {
          this.pageData = response.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          this.loading = true 
        })
        .finally(() => { 
          this.loading = false 
          document.body.style.overflow = ''
        })

      const hasHover = window.matchMedia('(hover: hover)').matches
      if (hasHover) {
        document.documentElement.classList.add('has-hover')
      }

      objectFitImages()

      this.componentReady = true
    },

    methods: {

    }
  }
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  min-height: 100vh;
}
</style>
